<script setup>
    import { computed } from 'vue'
    import Checkbox from 'primevue/checkbox'

    import AlertPrice from '@/views/dash/channels/Pages/AlertPrice'
    import { useChannelsStore } from '@/stores/channels'
    import { useRouter } from 'vue-router'

    const router = useRouter()
    const store = useChannelsStore()
    store.formStep = 2

    if (!store.channel.more) {
        store.channel.more = {}
    }

    const permitReply = computed({
        get() {
            const value = store.channel?.more?.permit_reply
            return value === true || value === 'true'
        },
        set(value) {
            store.channel.more.permit_reply = value === true
        }
    })

    const ignoreStoriesMentions = computed({
        get() {
            const value = store.channel?.more?.ignore_stories_mentions
            return value === true || value === 'true'
        },
        set(value) {
            store.channel.more.ignore_stories_mentions = value === true
        }
    })

    function handlePermitReplyLabelClick() {
        permitReply.value = !permitReply.value
    }

    function handleIgnoreStoriesMentionsLabelClick() {
        ignoreStoriesMentions.value = !ignoreStoriesMentions.value
    }

    const redirectUriBase = () => {
        const uri = `${window.location.origin}/v2/canais/cadastrar/whatsapp/instagram`
        if (uri.includes('localhost')) {
            return 'https://v2.chatmix.com.br/v2/canais/cadastrar/whatsapp/instagram'
        }

        return uri
    }

    // Old scopes is deprecated
    // https://developers.facebook.com/docs/instagram-platform/instagram-api-with-instagram-login
    const scopes = [
        'instagram_business_basic',
        'instagram_business_manage_messages',
        'instagram_business_manage_comments',
        'instagram_business_content_publish',
    ]
    const link = `https://www.instagram.com/oauth/authorize?client_id=2247928348911196&redirect_uri=${redirectUriBase()}&response_type=code&scope=${scopes.join(',')}`

    const isEdit = computed(() => Boolean(store.channel?.id))

    const openPopUp = () => {
        window.open(link, '_blank', `width=500,height=500`)

        setTimeout(() => router.push({ name: 'channels.home' }), 2000)
    }

</script>

<template>
    <div class="space-y-4">
        <button
            class="flex justify-center bg-gradient-to-r from-indigo-500 via-purple-500 to-pink-600 text-white text-sm font-bold py-2 px-4 rounded-full mt-3 chat_transition"
            @click.prevent.stop="openPopUp"
        >
            <Unicon name="instagram" class="h-5 w-5 mr-2" />
            Cadastrar Instagram
        </button>

        <div
            v-if="isEdit"
            class="flex items-start gap-3 p-4 border border-slate-200 bg-white rounded-lg dark:border-slate-700 dark:bg-slate-800/40"
        >
            <Checkbox
                input-id="permit-reply"
                v-model="permitReply"
                :binary="true"
                class="mt-0.5 shrink-0"
            />
            <label for="permit-reply" class="cursor-pointer" @click.prevent="handlePermitReplyLabelClick">
                <p class="text-sm font-medium text-slate-700 dark:text-slate-100">
                    Permitir respostas de stories
                </p>
                <p class="text-xs text-slate-500 mt-1 dark:text-slate-300">
                    Ao habilitar essa função o sistema irá permitir mensagens originadas de respostas em stories.
                </p>
            </label>
        </div>

        <div
            v-if="isEdit"
            class="flex items-start gap-3 p-4 border border-slate-200 bg-white rounded-lg dark:border-slate-700 dark:bg-slate-800/40"
        >
            <Checkbox
                input-id="ignore-stories-mentions"
                v-model="ignoreStoriesMentions"
                :binary="true"
                class="mt-0.5 shrink-0"
            />
            <label for="ignore-stories-mentions" class="cursor-pointer" @click.prevent="handleIgnoreStoriesMentionsLabelClick">
                <p class="text-sm font-medium text-slate-700 dark:text-slate-100">
                    Ignorar menções de stories
                </p>
                <p class="text-xs text-slate-500 mt-1 dark:text-slate-300">
                    Ao habilitar essa função o sistema irá ignorar mensagens originadas de menções em stories.
                </p>
            </label>
        </div>

        <AlertPrice />
    </div>
</template>